module.exports = __webpack_public_path__ + "static/img/20180414165955.b0f83efe.jpg";